Date.prototype.stdTimezoneOffset = function() {
    let jan = new Date(this.getFullYear(), 0, 1);
    let jul = new Date(this.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

let featuresExpanded = false;

$(document).off('click', '.see-features-link').on('click', '.see-features-link', function () {
	let planId = $(this).data('plan');
	let $extras = $('#features-' + planId + ' .extra-feature');

	if (featuresExpanded) {
		$extras.slideUp(200);
		$(this).text("See all features");
		featuresExpanded = false;
	} else {
		$extras.slideDown(200);
		$(this).text("Hide features");
		featuresExpanded = true;
	}
});

$(document).on('change', '#plan-dropdown', function () {
	let selected = $(this).val();
	$('.plan-features-card').hide();
	$('#features-' + selected).show();
	if (featuresExpanded) {
		$('#features-' + selected + ' .extra-feature').show();
		$('#features-' + selected + ' .see-features-link').text("Hide features");
	} else {
		$('#features-' + selected + ' .extra-feature').hide();
		$('#features-' + selected + ' .see-features-link').text("See all features");
	}
});

$(document).ready(function () {
	let initial = $('#plan-dropdown').val();
	if (initial) {
		$('.plan-features-card').hide();
		$('#features-' + initial).show();
	}
	$("#new_user").on("submit", function () {
		$(this).find(":submit").prop("disabled", true);
	});
});

